<div class="sec-title">
  <h1>Ajouter un client</h1>
</div>

<div><a class="btn btn-action" href="/clients" routerLink="/clients" role="button"><i class="bi bi-arrow-90deg-left"></i> retour aux clients</a></div>
<div style="width:100%;">
  <form [formGroup]="addClientForm" (ngSubmit)="onSubmit(addClientForm.value, clientTypeForm.value)" class="needs-validation autocomplete-form" novalidate>

    <fieldset class="col-12 float-lg-left form-group mb-3">
      <legend>Information personelle</legend>
      <div class="fieldset-wrap">
        <div class="float-lg-start col-sm-12 col-lg-5 ">

          <div class="form-group mb-3">
              <label for="first_name" class="form-label">Prénom</label>
              <input class="form-control"  list="datalistOptions" id="first_name" formControlName="first_name" required placeholder="Prénom du client..." (keyup)="onChangeAutoName($event.target, 'name')"  #device  (change)="goToAutoName($event, device.value)" >
              <datalist id="datalistOptions"  #datalistOption>
                <option  *ngFor="let autoClient of clientAutoInfo" [value]="'ID '+autoClient.client_id" [id]="autoClient.client_id" >
                {{autoClient.client_fname+' '+autoClient.client_lname+' ('+autoClient.client_address+')'}}
                </option>
              </datalist>
          </div>
        <!--
          <div class="form-group mb-3">
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let option of options" [value]="option">
                {{option}}
              </mat-option>
            </mat-autocomplete>
          </div>
 
          <div class="form-group mb-3">
            <label for="first_name" class="form-label">Prénom</label>
            <input type="text" class="form-control" name="first_name" id="first_name" formControlName="first_name" required />
          </div>

          <div class="form-group mb-3">
            <label for="last_name" class="form-label">Nom</label>
            <input type="text" class="form-control" name="last_name" id="last_name" formControlName="last_name" required />
          </div>
        -->  

          <div class="form-group mb-3">
              <label for="last_name" class="form-label">Nom</label>
              <input class="form-control"  list="datalistOptionsLastName" id="last_name" formControlName="last_name" required placeholder="Nom du client..." (keyup)="onChangeAutoName($event.target, 'name' )"  #deviceLast  (change)="goToAutoName($event, deviceLast.value )" >
              <datalist id="datalistOptionsLastName"  #datalistOptionsLastName>
                <option  *ngFor="let autoClient of clientAutoInfo" [value]="'ID '+autoClient.client_id" [id]="autoClient.client_id" >
                {{autoClient.client_fname+' '+autoClient.client_lname+' ('+autoClient.client_address+')'}}
                </option>
              </datalist>
          </div>

          <div class="form-group mb-3">
            <label for="gender" class="form-label">Genre</label>
            <select class="form-select" name="gender" id="gender" formControlName="gender" required>
              <option value="N/A" selected>N/A</option>
              <option value="M">Homme</option>
              <option value="F">Femme</option>
            </select>
          </div>
          <div class="form-group mb-3" [formGroup]="clientTypeForm" *ngFor="let contactType of contactTypeList; let i = index;">
            <div *ngIf="contactType.client_contact_type_id==4;then email_wrap" ></div>
            <ng-template #email_wrap>
<!--
              <div class="mb-3 col-12">
                <label for="contact_type_email0-4" class="col-10 form-label">{{contactType.name}}</label>
                <div class="float-start col-10 form-group mb-3 ">
                  <input type="text" list="datalistOptionsEmail" class="form-control" name="contact_type_email0-4" formControlName="contact_type_email0-4" required placeholder="Courriel..." (keyup)="onChangeAutoEmail($event.target, 'email', i )"  #deviceLast  (change)="goToAutoName($event, deviceLast.value )" />
                  <input type="hidden" class="form-control" id="id_email0_4" value="4" />
                  <datalist id="datalistOptionsEmail"  #datalistOptionsEmail>
                    <option  *ngFor="let autoClient of clientAutoInfo" [value]="'ID '+autoClient.client_id" [id]="autoClient.client_id" >
                    {{autoClient.contacts[0].value+' ('+autoClient.client_fname+' '+autoClient.client_lname+')'}}
                    </option>
                  </datalist>
                </div>  
              </div>
              <div class="mb-3 col-12" *ngFor="let clientEmail of clientEmails| slice:1; let i = index;">
                  <label for="contact_type_email{{i+1}}-{{contactType.client_contact_type_id}}" class="col-10 form-label">{{contactType.name}} {{i+2}}</label>
                  <div class="float-end col-2">
                    <div class="form-group mb-3 ms-3 col-12" *ngIf="i+1>0">
                      <span>
                        <a href="javascript:void(0);" (click)="removeEmailClient(i-2)" role="button" class="btn-delete"><i class="bi bi-file-x-fill"></i></a>
                      </span>
                    </div>
                  </div>
                  <div class="float-start col-10 form-group mb-3 ">
                  <input type="text" class="form-control" name="contact_type_email{{i+1}}-{{contactType.client_contact_type_id}}" formControlName="contact_type_email{{i+1}}-{{contactType.client_contact_type_id}}" (change)="onChangeEmail(i+1, $event.target)" />
                  <input type="hidden" class="form-control" id="id_email{{i+1}}_{{contactType.client_contact_type_id}}" value="{{contactType.client_contact_type_id}}" />
                  </div>
                  
              </div>
            -->
              <div class="mb-3 col-12" *ngFor="let clientEmail of clientEmails; let i = index;">
                  <label for="contact_type_email{{i}}-{{contactType.client_contact_type_id}}" class="col-10 form-label">{{contactType.name}} {{i}}</label>
                  <div class="float-end col-2">
                    <div class="form-group mb-3 ms-3 col-12" *ngIf="i+1>0">
                      <span>
                        <a href="javascript:void(0);" (click)="removeEmailClient(i)" role="button" class="btn-delete"><i class="bi bi-file-x-fill"></i></a>
                      </span>
                    </div>
                  </div>
                  <div class="float-start col-10 form-group mb-3 ">
                  <input type="text" class="form-control" name="contact_type_email{{i}}-{{contactType.client_contact_type_id}}" formControlName="contact_type_email{{i}}-{{contactType.client_contact_type_id}}" (change)="onChangeEmail(i, $event.target)" />
                  <input type="hidden" class="form-control" id="id_email{{i}}_{{contactType.client_contact_type_id}}" value="{{contactType.client_contact_type_id}}" />
                  </div>
                  
              </div>
            </ng-template>
          </div>
          <div class="float-start col-12">
            <div class="form-group mb-3 ms-3">
               <a href="javascript:void(0);" (click)="addEmailClient()" role="button">
                  <i class="bi bi-plus-circle-fill btn-add-one"></i>
                  <span class="txt-add-one ms-2">Ajouter un courriel</span>
              </a>
            </div>
          </div>
        </div>
        <div class="float-lg-end col-sm-12 col-lg-6 ">
          <div class="form-group mb-3" [formGroup]="clientTypeForm" >
            <div  class="form-group mb-3" *ngFor="let contactType of contactTypeList; let i = index;" >
              <div *ngIf="contactType.client_contact_type_id!=4;then contact_wrap" ></div>
              <ng-template #contact_wrap>
                <label for="contact_type_{{contactType.client_contact_type_id}}" class="form-label">{{contactType.name}}</label>
                <input type="text" class="form-control" name="contact_type_{{contactType.client_contact_type_id}}" formControlName="contact_type_{{contactType.client_contact_type_id}}" />
                <input type="hidden" class="form-control" id="id_{{contactType.client_contact_type_id}}" value="{{contactType.client_contact_type_id}}" />
              </ng-template>
            </div>
          </div>   
        </div>
      </div>
    </fieldset>

    <fieldset class="col-12 float-lg-left form-group mb-3">
      <legend>Adresse</legend>
      <div class="fieldset-wrap">

        <div class="float-lg-start col-sm-12 col-lg-5 ">
          <!--
          <div class="form-group mb-3">
            <label for="address" class="form-label">Adresse</label>
            <input type="text" class="form-control" name="address" id="address" formControlName="address" />
          </div>
         -->
          <div class="form-group mb-3">
            <label for="address" class="form-label">Adresse</label>
            <input class="form-control"  list="datalistOptionsAddress" id="address" formControlName="address" required placeholder="Adresse..." (keyup)="onChangeAutoName($event.target, 'address')"  #deviceAddress  (change)="goToAutoName($event, deviceAddress.value)" >
            <datalist id="datalistOptionsAddress"  #datalistOptionsAddress>
              <option  *ngFor="let autoClient of clientAutoInfo" [value]="'ID '+autoClient.client_id" [id]="autoClient.client_id" >
              {{autoClient.client_address +' ('+autoClient.client_fname+' '+autoClient.client_lname+')'}}
              </option>
            </datalist>
          </div>

          <div class="form-group mb-3">
            <label for="city" class="form-label">Ville</label>
            <input type="text" class="form-control" name="city" id="city" formControlName="city" />
          </div>

          <div class="form-group mb-3">
            <label for="postalcode" class="form-label">Code Postal</label>
            <input type="text" class="form-control" name="postalcode" id="postalcode" formControlName="postalcode" />
          </div>

        </div>
        <div class="float-lg-end col-sm-12 col-lg-6">

          <div class="form-group mb-3">
            <label for="address2" class="form-label">App/Suite</label>
            <input type="text" class="form-control" name="address2" id="address2" formControlName="address2" />
          </div>

          <div class="form-group mb-3">
            <label for="province" class="form-label">Province</label>
            <input type="text" class="form-control" name="province" id="province" formControlName="province" />
          </div>

          <div class="form-group mb-3">
            <label for="country" class="form-label">Pays</label>
            <input type="text" class="form-control" name="country" id="country" formControlName="country" />
          </div>

        </div>
      </div>
    </fieldset>

    <fieldset class="col-12 float-lg-left form-group mb-3">
      <legend>Autres informations</legend>
      <div class="fieldset-wrap">
        
          <div class="form-group float-lg-start mb-3 col-sm-12 col-lg-5">
            <label for="referral" class="form-label">Provenance de la publicité</label>
            <select class="form-select" name="referral" id="referral" formControlName="referral" aria-label="select example" required>
              <option *ngFor="let referral of referralList" [value]="referral.client_referral_id">
                {{referral.name}}
              </option>
            </select>
            <div class="invalid-feedback">Example invalid select feedback</div>
          </div>
          <div class="form-group float-lg-end mb-3 col-sm-12 col-lg-6">
            <label for="referral_note" class="form-label">Référence</label>
            <textarea class="form-control" name="referral_note" id="referral_note" formControlName="referral_note"></textarea>
          </div>

          <div class="form-group mb-3 col-5">
            <label for="language" class="form-label">Langue</label>
            <select class="form-select" name="language" id="language" formControlName="language" required>
              <option *ngFor="let language of languageList" [value]="language.client_language_id">
                  {{language.name}}
              </option>
            </select>
          </div>
      </div>
    </fieldset>

    <button type="submit" class="btn btn-primary">Enregistrer</button>

  </form>
</div>
<hr/>